import en from '@/config/locales/en.json';
import id from '@/config/locales/id.json';
import { createI18n } from 'vue-i18n';

export default createI18n({
  legacy: false,
  locale: 'id',
  fallbackLocale: 'en',
  messages: { id, en },
  // missing: (locale, key) => {
  //   if (/^fields\.\w+\.name$/.test(key)) {
  //     return 'Field is required'; // → This is shown in the UI, not the console
  //   }
  //   // If return undefined or null → nothing shows in UI
  // },
  missingWarn: false, // Suppress 'Not found key' warnings
  fallbackWarn: false, // Suppress 'Fall back to translate' warnings
});
